import DrawerList from "./drawer-list/DrawerList";
import React from "react";
import PropTypes from "prop-types";
import {drawerWidth} from "./SidebarStyles";
import {theme} from "../../../shared/theme/theme";
import Copyright from "../../../shared/components/copyright/Copyright";
import {Box, Drawer, List} from "@mui/material";

const Sidebar = (props) => {
    const container = props.window !== undefined ? () => window.document.body : undefined;

    return (
        <nav sx={{
                [theme.breakpoints.up('sm')]: {
                width: `${drawerWidth}px`,
                flexShrink: 0,
            }}
        } aria-label="mailbox folders">
            <Box sx={{display: { sm: "none"}}}>
                <Drawer
                    container={container}
                    variant="temporary"
                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                    open={props.sidebarOpen}
                    onClose={props.handleSidebarToggle}
                    PaperProps={{
                        sx: {
                            width: `${drawerWidth}px`,
                            backgroundColor: theme.palette.secondary.main
                        }
                    }}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                >
                    <DrawerList/>
                    <List style={{bottom: 0, position: "absolute", paddingLeft:"0.7em"}}>
                        <Copyright/>
                    </List>
                </Drawer>

            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                <Drawer
                    PaperProps={{
                        sx: {
                            width: `${drawerWidth}px`,
                            backgroundColor: theme.palette.secondary.main
                        }
                    }}
                    variant="permanent"
                    open={true}>
                    <DrawerList/>
                    <List style={{bottom: 0, position: "absolute", paddingLeft:"0.5em"}}>
                        <Copyright/>
                    </List>
                </Drawer>
            </Box>
        </nav>
    )
}

Sidebar.propTypes = {
    sidebarOpen : PropTypes.bool.isRequired,
    handleSidebarToggle: PropTypes.func.isRequired
}
export default Sidebar;
